import React from "react"
import { UserNotificationTypeForm } from "../../components/forms/UserNotificationTypeForm"

export const NotificationSettings = () => {
	return (
		<UserNotificationTypeForm/>
	)
}
